import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import DownloadIcon from "@mui/icons-material/Download";

const exportToCSV = (rows, columns, filename) => {
  const selectedColumns = columns.filter(
    (column) =>
      column.field === "onekeyMatched" ||
      column.field === "firstName" ||
      column.field === "lastName" ||
      column.field === "fullName" ||
      column.field === "imcId" ||
      column.field === "oneKeyId" ||
      column.field === "wpName" ||
      column.field === "address" ||
      column.field === "city" ||
      column.field === "state" ||
      column.field === "postCode" ||
      column.field === "specialty" ||
      column.field === "email" ||
      column.field === "phone"
  );

  const csvRows = [];
  const headers = selectedColumns.map((col) => `"${col.headerName}"`);
  csvRows.push(headers.join(","));

  rows.forEach((row) => {
    const values = selectedColumns.map((col) => {
      const value = row[col.field];
      if (typeof value === "string" && (value.includes(","))) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    });
    csvRows.push(values.join(","));
  });

  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("hidden", "");
  a.setAttribute("href", url);
  a.setAttribute("download", `${filename}.csv`);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

function CustomToolbar({ rows, columns }) {
  const [open, setOpen] = useState(false);
  const [filename, setFilename] = useState("");

  const handleExportClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    if (filename) {
      exportToCSV(rows, columns, filename);
      setOpen(false);
    }
  };

  return (
    <GridToolbarContainer>
      <Stack spacing={2} direction="row">
      <GridToolbarColumnsButton style={{ color: "#ab1368" }} />
      {/* <GridToolbarDensitySelector /> */}
        <Button
          onClick={handleExportClick}
          startIcon={<DownloadIcon />}
          sx={{ color: "#1976d2" }}
        >
          EXPORT
        </Button>
      </Stack>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Export CSV</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter a filename for the exported CSV.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Filename"
            type="text"
            fullWidth
            variant="standard"
            value={filename}
            onChange={(e) => setFilename(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleConfirm}>Export</Button>
        </DialogActions>
      </Dialog>
    </GridToolbarContainer>
  );
}

const CompletedRecordDisplayGrid = ({ rows, columns, completedColumnVisibilityModel, setcompletedColumnVisibilityModel }) => {
  return (
    <>
      <Box sx={{ height: "500px", width: "96%", marginTop: "20px" }}>
        <DataGrid
          slots={{
            toolbar: () => <CustomToolbar rows={rows} columns={columns} />,
          }}
          rowHeight={50}
          rows={rows}
          columns={columns}
          sx={{
            "& .MuiDataGrid-row": {
              backgroundColor: "dadfe1",
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#dee3eb",
              color: "#ab1368",
              fontSize: 16,
            },
            overflowX: "scroll",
            border: "2px solid #ab1368",
            borderRadius: "5px",
          }}
          initialState={{
            density: "compact",
            columns: {
              completedColumnVisibilityModel: completedColumnVisibilityModel,
            },
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          pageSizeOptions={[25, 50, 75, 100]}
          disableRowSelectionOnClick
          columnVisibilityModel={completedColumnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setcompletedColumnVisibilityModel(newModel)
          }
        />
      </Box>
    </>
  );
};

export default CompletedRecordDisplayGrid;
